import "./fixed-header.css";
import React, { useContext } from "react";
import { UserContext } from "../App";

export const FixedHeader = () => {

  const data = useContext(UserContext);
  const menuItems = [];

  const section = data.sections;

  if(section.project_section){
    menuItems.push(<a href="#projects" key={section.type}>Projects</a>);
  } 
  if(section.media_sec ){
    menuItems.push(<a href="#media" key={section.type}>Media</a>);
  } 
  if(section.experience_section ){
    menuItems.push(<a href="#experiance" key={section.type}>Experience</a>);
  }
  if(section.education_sec){
    menuItems.push(<a href="#education" key={section.type}>Education</a>);
  }
  if(section.awards_section){
    menuItems.push(<a href="#awards" key={section.type}>Awards</a>);
  }
  if(section.testimonial_section ){
    menuItems.push(<a href="#testimonials" key={section.type}>Testimonials</a>);
  }

  console.log()

  return (
    <div className="fixed-header-container">
      <div className="fixed-header">
        <a href="#about" key="about">About</a>
        {menuItems}
      </div>
    </div>
  );
};
